import axios from 'axios';

import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import {URL} from '../root';

const FUNCTION_CODE = 'UPDATE_PROJECT';

export async function updateProject(token: string, projectId: number | string, payload: Record<string, unknown>) {
    try {
        const response = await axios({
            method: 'patch',
            url: `${URL}/projects/${projectId}/`,
            data: payload,
            headers: {
                Accept: 'application/json',
                Authorization: `Token ${token}`
            }
        });

        return response.data;
    }
    catch (error: any) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la mise à jour du projet',
            error: error
        });
    }
}
